/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cashFrontendServiceCookieRefresh} from '../api'

export const useMutationCashFrontendServiceCookieRefresh = createReactQueryMutationHook('cashFrontendServiceCookieRefresh', cashFrontendServiceCookieRefresh)
